import styled from 'styled-components';

export const StyledBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
